import { SALES_PERSON_REQUEST, CREATE_SALES_PERSON, GET_SALES_PERSON, UPDATE_SALES_PERSON, DELETE_SALES_PERSON, 
SALES_PERSON_REQUEST_FAILURE, SALES_PERSON_REQUEST_SUCCESS, GET_SALES_PERSON_PAGE } from '../types';

const initialState = {
  salesPersons: [],
  salesPersonsPage: [],
  loading: false,
  error: null,
};

const salesPersonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SALES_PERSON_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_SALES_PERSON: {
      return {
        ...state,
        salesPersons: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_SALES_PERSON_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        salesPersonsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_SALES_PERSON:
      return {
        ...state,
        salesPersons: [action.payload, ...state.salesPersons],
        loading: false,
        error: null
      };
    case UPDATE_SALES_PERSON:
      const salesPersonsData = state.salesPersons.slice(0);
      const uIndex = salesPersonsData.findIndex((data) => data.id === action.payload.id);
      salesPersonsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        salesPersons: [ ...salesPersonsData ],
        loading: false,
        error: null
      };
    case DELETE_SALES_PERSON:
      const salesPersons = state.salesPersons?.slice(0);
      const index = salesPersons.findIndex((data) => data.id === action.id);
      if (index > -1) {
        salesPersons.splice(index, 1);
      }
      return {
        ...state,
        salesPersons: [...salesPersons],
        loading: false,
        error: null
      }
    case SALES_PERSON_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case SALES_PERSON_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default salesPersonReducer;
